// Handles adding a page to the pages key
export const addPageToPages = (queryClient, newPage, workspaceID) => {
  const pages = queryClient.getQueryData(["pages", workspaceID]);

  if (!pages) return;

  queryClient.setQueryData(["pages", workspaceID], (prevPages) => {
    return [...prevPages, newPage];
  });
};

// Handles update of the pages key
export const updatePageInPages = (queryClient, newPage, workspaceID) => {
  const pages = queryClient.getQueryData(["pages", workspaceID]);

  if (!pages) return;

  queryClient.setQueryData(["pages", workspaceID], (prevPages) =>
    prevPages.map((page) => {
      if (page.id === newPage.id) {
        return newPage;
      }
      return page;
    })
  );
};

// Handles delete of page in pages key
export const deletePageInPages = (queryClient, pageID, workspaceID) => {
  const pages = queryClient.getQueryData(["pages", workspaceID]);

  if (!pages) return;

  queryClient.setQueryData(["pages", workspaceID], (prevPages) => {
    if (!prevPages || !Array.isArray(prevPages)) return;

    return prevPages.filter((page) => page.id !== pageID);
  });
};
